<template>
  <div>
    <scout-members
      :member-objects="scoutedMemberObjects"
      :contract-id="Number($route.params.contractId)"
      :job-id="Number($route.params.jobId)"
      display-key="recommended"
      data-test="scout-members"
      :count="recommendedMembers.length"
      :count-limit="recommendedMembers.length"
      @fetch="fetchRecommendedMembers"
    />
  </div>
</template>

<script>
import ScoutMembers from '@/components/organisms/ScoutMembers.vue'
import Indicator from '@/lib/indicator'
import _ from 'lodash'

export default {
  components: {
    ScoutMembers
  },
  data () {
    return {
      recommendedMembers: []
    }
  },
  computed: {
    scoutedMemberObjects () {
      return this.recommendedMembers.map((recommendedMember) => {
        return {
          id: recommendedMember.recommendedId,
          member: recommendedMember
        }
      })
    }
  },
  watch: {
    $route: {
      handler: 'fetchRecommendedMembers'
    }
  },
  created () {
    this.fetchRecommendedMembers()
  },
  methods: {
    fetchRecommendedMembers () {
      Indicator.emitShow()
      this.$http.secured.get(`/scout/view/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/recommended_users`)
        .then(response => {
          this.setProperty(response.data)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    setProperty (recommendedMembers) {
      this.$set(this, 'recommendedMembers', recommendedMembers.map(recommendedMember => _.set(recommendedMember, 'isScoutExcluded', false)))
    }
  }
}
</script>
